import { Dialog, DialogBoddy, DialogFooter, DialogHeader } from './dialog';

export interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  warningMessage?: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  variant?: 'danger' | 'default';
}

export function ConfirmModal({
  isOpen,
  title,
  message,
  warningMessage,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  isLoading = false,
  variant = 'default',
}: ConfirmModalProps) {
  return (
    <Dialog isOpen={isOpen} onClose={onCancel}>
      <DialogHeader>{title}</DialogHeader>
      <DialogBoddy>
        <p className="text-muted mb-4">{message}</p>
        {warningMessage && (
          <p className="text-warning text-sm">{warningMessage}</p>
        )}
      </DialogBoddy>

      <DialogFooter
        abortText={cancelLabel}
        submitText={confirmLabel}
        onSubmit={onConfirm}
        abortButtonProps={{ disabled: isLoading }}
        submitButtonProps={{ disabled: isLoading }}
        submitButtonClassName={
          variant === 'danger' ? 'bg-error hover:bg-error/90' : ''
        }
      />

      {/* <DialogFooter>
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onCancel}
            disabled={isLoading}
            className="px-4 py-2 text-sm font-medium text-muted hover:text-onsurface transition-colors disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <PrimaryButton
            onClick={onConfirm}
            disabled={isLoading}
            className={variant === 'danger' ? 'bg-error hover:bg-error/90' : ''}
          >
            {confirmLabel}
          </PrimaryButton>
        </div>
      </DialogFooter> */}
    </Dialog>
  );
}
